<template>
  <message-template :direction="'outgoing'" :time="time" :channel="channel">
    <div class="log-button-template-block message-bg">
      <div class="template-text" v-if="data && data.title">
        <span>{{data.title}}</span>
      </div>
      <div class="template-text" v-if="data && data.text">
        <span>{{data.text}}</span>
      </div>
      <div class="field" v-for="(button,index) in data.buttons" :key="'log-btn-'+index">
        <div class="control is-expanded">
          <button
            class="button is-fullwidth"
            v-if="button.type === 'uri' || button.type === 'webview'"
            :title="button.uri"
          >{{button.label || button.title}}</button>
          <button
            class="button is-fullwidth"
            v-else-if="button.type === 'postback'"
            :title="button.payload"
          >{{button.label || button.title}}</button>
          <button
            class="button is-fullwidth"
            v-else-if="button.type === 'web_url'"
            :title="button.url"
          >{{button.title}}</button>
          <button class="button is-fullwidth" v-else-if="button.label">{{button.label}}</button>
          <button v-else>Button</button>
        </div>
      </div>
    </div>
  </message-template>
</template>
<script>
import MessageTemplate from './MessageTemplate.vue';

export default {
  name: 'buttonTemplate',
  components: {
    'message-template': MessageTemplate,
  },
  props: {
    data: {
      type: Object,
    },
    time: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
.log-button-template-block {
  background-color: #efefef;
  padding: 10px;
  display: inline-block;
  text-align: left;
  border-radius: 10px 0 10px 10px;
  .template-text {
    margin-bottom: 5px;
  }
}
</style>
